import Vue from 'vue'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

Vue.use(VueTelInput, {
  mode: 'international',
  defaultCountry: 'PL',
  enabledCountryCode: true,
  preferredCountries: ['PL'],
  validCharactersOnly: true,
  autoFormat: true,
  dropdownOptions: {
    showDialCodeInList: true,
    showDialCodeInSelection: false,
    showFlags: true
  },
  inputOptions: { placeholder: 'Nr telefonu', required: false }
})
